

<!-- Filter panel -->
<div class="container">
  <div class="row">

    <!-- Filter toggle icon -->
    <div class="col-xs-12">
      <div class="pull-right" style="margin-right: 10px; margin-bottom: 6px;">
        <span title="Click to show / hide the filter" class="pull-right filter-icon">
          <i class="fa fa-filter fa-2x cursor-point" aria-hidden="true" id="ai-open-filter"></i>
        </span>
      </div>
    </div>

    <!-- Filter panel -->
    <div class="col-xs-12">
      <div class="row">
        <div class="col-xs-12" id="ai-search-panel" style="display: none;">
          <div class="main-box" style="padding-top: 1%;">
            <div class="main-box-body clearfix">
              <form role="form" novalidate autocomplete="off">
                <div class="row">
                  <div class="col-lg-12 col-sm-12 col-md-12">
                    <div class="row">

                      <!-- Client/Bu --> 
                      <div class="col-lg-3 col-sm-3 col-md-3">
                        <div class="form-group">
                          <label for="aiClientOrBu">{{isStaffingCompany ? 'Client' : 'Client Name'}}</label>
                          <select class="form-control access inputBoxBorder"
                                  [(ngModel)]="activityFilter.clientOrBuId"
                                  (change)="onClientOrBuChange()"
                                  name="aiClientOrBu" id="aiClientOrBu">
                            <option value="any">Any</option>
                            <option *ngFor="let client of clientsOrBus" [value]="client.id">
                              {{client.name}}
                            </option>
                          </select>
                        </div>
                      </div>

                      <!-- Requisition -->
                      <div class="col-lg-3 col-sm-3 col-md-3">
                        <div class="form-group">
                          <label for="aiRequisition">Requisition</label>
                          <select class="form-control access inputBoxBorder"
                                  [(ngModel)]="activityFilter.requisitionId"
                                  (change)="loadActivities()"
                                  name="aiRequisition" id="aiRequisition">
                            <option value="any">Any</option>
                            <option *ngFor="let req of requisitions" [value]="req.reqNumber">
                              {{req.reqNumber}}
                            </option>
                          </select>
                        </div>
                      </div>

                      <!-- Start Date -->
                      <div class="col-lg-3 col-sm-3 col-md-3">
                        <div class="form-group">
                          <label for="ai-startDate" class="control-label">Start Date:</label>
                          <div class="input-group">
                            <div class="input-group-addon">
                              <div class="input-group-text"><i class="fa fa-calendar"></i></div>
                            </div>
                            <input type="text" name="aiStartDate" id="ai-startDate"
                                   class="form-control" [(ngModel)]="startDate"
                                   placeholder="Choose Start Date" autocomplete="off">
                          </div>
                        </div>
                      </div>

                      <!-- Start Time -->
                      <div class="col-lg-3 col-sm-3 col-md-3">
                        <div class="form-group">
                          <label for="ai-startTime" class="control-label">Start Time:</label>
                          <div class="input-group">
                            <div class="input-group-addon">
                              <div class="input-group-text"><i class="far fa-clock"></i></div>
                            </div>
                            <input type="text" name="aiStartTime" id="ai-startTime"
                                   class="form-control" [(ngModel)]="startTime">
                          </div>
                        </div>
                      </div>

                      <!-- End Date -->
                      <div class="col-lg-3 col-sm-3 col-md-3">
                        <div class="form-group">
                          <label for="ai-endDate" class="control-label">End Date:</label>
                          <div class="input-group">
                            <div class="input-group-addon">
                              <div class="input-group-text"><i class="fa fa-calendar"></i></div>
                            </div>
                            <input type="text" name="aiEndDate" id="ai-endDate"
                                   class="form-control" [(ngModel)]="endDate"
                                   placeholder="Choose End Date" autocomplete="off">
                          </div>
                        </div>
                      </div>

                      <!-- End Time -->
                      <div class="col-lg-3 col-sm-3 col-md-3">
                        <div class="form-group">
                          <label for="ai-endTime" class="control-label">End Time:</label>
                          <div class="input-group">
                            <div class="input-group-addon">
                              <div class="input-group-text"><i class="far fa-clock"></i></div>
                            </div>
                            <input type="text" name="aiEndTime" id="ai-endTime"
                                   class="form-control" [(ngModel)]="endTime">
                          </div>
                        </div>
                      </div>

                      <!-- Activity Performed By -->
                      <div class="col-lg-3 col-sm-3 col-md-3">
                        <div class="form-group">
                          <label for="aiCreatedBy">Activity Performed By:</label>
                          <select class="form-control access inputBoxBorder"
                                  [(ngModel)]="activityFilter.createdBy"
                                  (change)="loadActivities()"
                                  name="aiCreatedBy" id="aiCreatedBy">
                            <option value="any">Any</option>
                            <option *ngFor="let user of users" [value]="user.id">{{user.name}}</option>
                          </select>
                        </div>
                      </div>

                      <!-- Text Search -->
                      <!-- <div class="col-lg-3 col-sm-3 col-md-3">
                        <div class="form-group">
                          <label for="aiTextSearch">Text Search:</label>
                          <input type="text" class="form-control" id="aiTextSearch" name="aiTextSearch"
                                 [(ngModel)]="textSearch" (keyup)="applyTextSearch()"
                                 placeholder="Search by candidate, role, user...">
                        </div>
                      </div> -->

                    </div>
                  </div>
                </div>
                <div class="row pull-right" style="margin-right: 10px;">
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <div class="form-group">
                      <button type="button" class="btn btn-danger" (click)="resetFilters()">Reset</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Filtered results badge -->
    <div class="col-xs-12 text-center" *ngIf="isFiltersEnabled">
      <span class="badge badge-primary px-3 py-2 mb-3">Filtered Results</span>
    </div>

  </div>
</div>

<div class="container" *ngIf="isLoading">
  <div class="col-xs-12 entity-activities-container" *ngFor="let row of [0, 1, 2, 3, 4]">
    <div class="col-xs-10 d-flex">
      <div class="entity-activities-icon-div"></div>
      <div style="width: 95%;">
        <div class="skeleton-loading skeleton-paragraph width-75 mb-2"></div>
        <div class="skeleton-loading skeleton-paragraph width-25 mb-2"></div>
        <div class="skeleton-loading skeleton-paragraph width-50"></div>
      </div>
    </div>
    <div class="col-xs-2">
      <div class="skeleton-loading skeleton-paragraph width-75"></div>
    </div>
  </div>
</div>

<!-- Activities list -->
<div class="container" *ngIf="!isLoading">
  <div class="row">
    <div class="col-xs-12 text-center" *ngIf="activities.length === 0">
      <p class="text-muted" style="padding: 30px 0; font-size: 18px;">No Formalized Text found.</p>
    </div>
  </div>

  <div style="height: 75vh; overflow-y: scroll" *ngIf="activities.length > 0">
    <div class="col-xs-12 entity-activities-container" *ngFor="let activity of activities">
      <div class="col-xs-10 d-flex">
        <div class="text-right entity-activities-icon-div">
          <i class="fas fa-magic"></i>
        </div>
        <div style="width: 95%;">
          <span>
            Text formalized for
            <span class="emerald">{{ activity.candidateName }}</span>
            <span *ngIf="activity.requisitionDisplay && activity.requisitionDisplay !== '--'">
              for role <span class="emerald">{{ activity.requisitionDisplay }}</span>
            </span>
            <span *ngIf="activity.clientOrBUName && activity.clientOrBUName !== '--'">
              for <span class="emerald">{{ activity.clientOrBUName }}</span>
            </span>
            by <span class="emerald">{{ activity.userName }}</span>
          </span>
          <!-- Note icon to open details -->
          <span
            class="fas fa-clipboard notes-icon ml-2 cursor-pointer"
            tooltip="Click to view Formalized Text details"
            tooltip-placement="auto top-left"
            container="body"
            (click)="viewActivityDetails(activity)">
          </span>
          <br>
          <span *ngIf="activity.tone && activity.tone !== '--'" style="display: block;">
            <span class="emerald">Tone</span>: {{ activity.tone }}
          </span>
          <span *ngIf="activity.mode && activity.mode !== '--'" style="display: block;">
            <span class="emerald">Mode</span>: {{ activity.mode }}
          </span>
          <!-- <span *ngIf="activity.sourceScreen && activity.sourceScreen !== '--'" style="display: block;">
            <span class="emerald">Source</span>: {{ activity.sourceScreen }}
          </span> -->
          <span *ngIf="activity.externalNote" style="display: block;">
            <span class="emerald">External Note</span>: {{ activity.externalNote }}
          </span>
        </div>
      </div>
      <div class="col-xs-2 text-left">{{ activity.formattedTimestamp }}</div>
    </div>
  </div>
</div>


<!-- ── Activity Details Modal ─────────────────────────────── -->

<ng-template #detailsModalTemplate>
  <div class="modal-header" style="padding: 15px !important; border-bottom: 1px solid #e5e5e5;">
    <button type="button" class="close" aria-hidden="true" (click)="closeDetailsModal()">×</button>
    <h4 class="modal-title">Formalized Text Details</h4>
  </div>
  <div class="modal-body" *ngIf="selectedActivity">

    <!-- Section: Formalization Details -->
    <h5 class="emerald ai-modal-section-title">Formalization Details</h5>
    <table class="table table-bordered ai-modal-table">
      <tbody>
        <tr>
          <td class="ai-modal-label">Date / Time</td>
          <td>{{ selectedActivity.formattedTimestamp }}</td>
          <td class="ai-modal-label">End Date / Time</td>
          <td>{{ selectedActivity.formattedEndTimestamp }}</td>
        </tr>
        <tr>
          <td class="ai-modal-label">Duration</td>
          <td>{{ selectedActivity.duration }}{{ selectedActivity.duration !== '--' ? ' s' : '' }}</td>
          <td class="ai-modal-label">Source</td>
          <td>{{ toSentenceCase(selectedActivity.sourceScreen) }}</td>
        </tr>
        <tr>
          <td class="ai-modal-label">Tone</td>
          <td>{{ selectedActivity.tone }}</td>
          <td class="ai-modal-label">Mode</td>
          <td>{{ toSentenceCase(selectedActivity.mode) }}</td>
        </tr>
      </tbody>
    </table>

    <!-- Section: Candidate & Role -->
    <h5 class="emerald ai-modal-section-title">Candidate & Role</h5>
    <table class="table table-bordered ai-modal-table">
      <tbody>
        <tr>
          <td class="ai-modal-label">Candidate</td>
          <td>{{ selectedActivity.candidateName }}</td>
          <td class="ai-modal-label">Requisition</td>
          <td>{{ selectedActivity.requisitionDisplay }}</td>
        </tr>
        <tr>
          <td class="ai-modal-label">Company</td>
          <td>{{ selectedActivity.companyName }}</td>
          <td class="ai-modal-label">Client / BU</td>
          <td>{{ selectedActivity.clientOrBUName !== '--' ? selectedActivity.clientOrBUName : '—' }}</td>
        </tr>
      </tbody>
    </table>

    <!-- Section: Performed By -->
    <h5 class="emerald ai-modal-section-title">Performed By</h5>
    <table class="table table-bordered ai-modal-table">
      <tbody>
        <tr>
          <td class="ai-modal-label">User</td>
          <td>{{ selectedActivity.userName }}</td>
          <td class="ai-modal-label">Email</td>
          <td>{{ selectedActivity.userEmail }}</td>
        </tr>
      </tbody>
    </table>

    <!-- Section: AI Text -->
    <h5 class="emerald ai-modal-section-title">AI Text</h5>
    <table class="table table-bordered ai-modal-table">
      <tbody>
        <tr>
          <td class="ai-modal-label" style="width: 160px;">Original Text</td>
          <td style="white-space: pre-wrap; word-break: break-word;">
            <span [innerHTML]="selectedActivity.originalText"></span>
          </td>
        </tr>
        <tr>
          <td class="ai-modal-label">Formalized Text</td>
          <td style="white-space: pre-wrap; word-break: break-word;">
            <span [innerHTML]="selectedActivity.formalizedText"></span>
          </td>
        </tr>
        <tr *ngIf="selectedActivity.savedNote && selectedActivity.savedNote !== '--'">
          <td class="ai-modal-label">Saved Note</td>
          <td style="white-space: pre-wrap; word-break: break-word;">
            <span [innerHTML]="selectedActivity.savedNote"></span>
          </td>
        </tr>
        <tr *ngIf="selectedActivity.externalNote">
          <td class="ai-modal-label">External Note</td>
          <td style="white-space: pre-wrap; word-break: break-word;">
            <span [innerHTML]="selectedActivity.externalNote"></span>
          </td>
        </tr>
      </tbody>
    </table>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="closeDetailsModal()">Close</button>
  </div>
</ng-template>
